export function errorMessageParse(err) {
  if (err.message === '帳號、密碼或專屬碼錯誤') return err.message;
  // if (err.message.includes('該長照單非待載客狀態'))
  //   return '該長照單非待載客狀態';
  if (err.type === 'FormatError')
    return '輸入錯誤，請檢查輸入再確認送出（*記號為必填）';
  if (err.type === 'ApplicationError') return `${err.message}，無法更改`;
  if (err.type.includes('NotFound') || err.type.includes('SubsidyError'))
    return err.message;
  if (err.type === 'APIException') return err.message;
}
